namespace TabAurous.ECommerce {
    export interface ShippingItemsRow {
        TransItemId?: number;
        ECommOrderItemId?: number;
        TransId?: number;
        VoucherTypeId?: number;
        VoucherDate?: string;
        RefVoucherId?: number;
        DepartmentId?: number;
        ProductId?: number;
        PartyId?: number;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        LotNo?: string;
        CertificateNo?: string;
        RefNo?: string;
        ItemTypeId?: number;
        AttributeId?: number;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        CostMethodId?: number;
        CalcOnId?: number;
        UnitRate?: number;
        UnitLabour?: number;
        UnitCost?: number;
        NetAmount?: number;
        Discount?: number;
        DiscountPer?: number;
        GrossAmount?: number;
        CCGrossAmount?: number;
        CCNetAmount?: number;
        RefTransItemId?: number;
        RefTransId?: number;
        ImageName?: string;
        Remark?: string;
        SpecialRemark?: string;
        UserDescription?: string;
        ServerDate?: string;
        Remarks?: string;
        IsDisabled?: boolean;
        AckStatus?: number;
        DeliveryDate?: string;
        CompanyId?: number;
        BagStatus?: string;
        WstPer?: number;
        WstWt?: number;
        Purity?: number;
        PureWeight?: number;
        Status?: string;
        MetalId?: number;
        ProductCode?: string;
        ProductName?: string;
        TaxCode?: string;
        HSN?: string;
        HasBom?: boolean;
        Parts?: number;
        VoucherNo?: string;
        TransDate?: string;
        DeptName?: string;
        PosCustomerCode?: string;
        CustomerName?: string;
        BOMDetails?: ShippingBOMRow[];
        LaborDetails?: Purchase.OrderLaborRow[];
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        BrandId?: number;
        SuperTypeId?: number;
        CollectionId?: number;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
        Attribute?: string;
        CalcUnitId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        KaratId?: number;
        StockAllocation?: boolean;
        ProductSizeId?: number;
        MetalColorId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        Lab?: string;
        ECommOrderId?: number;
        OrderStatusId?: number;
        OrderStatusName?: string;
    }

    export namespace ShippingItemsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'ProductName';
        export const localTextPrefix = 'ECommerce.ShippingItems';
        export const deletePermission = 'Retail:Shipping:Delete';
        export const insertPermission = 'Retail:Shipping:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:Shipping:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            ECommOrderItemId = "ECommOrderItemId",
            TransId = "TransId",
            VoucherTypeId = "VoucherTypeId",
            VoucherDate = "VoucherDate",
            RefVoucherId = "RefVoucherId",
            DepartmentId = "DepartmentId",
            ProductId = "ProductId",
            PartyId = "PartyId",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SKU = "SKU",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            RefNo = "RefNo",
            ItemTypeId = "ItemTypeId",
            AttributeId = "AttributeId",
            Studded = "Studded",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            MetalAmount = "MetalAmount",
            DiamondAmount = "DiamondAmount",
            StoneAmount = "StoneAmount",
            OtherAmount = "OtherAmount",
            CostMethodId = "CostMethodId",
            CalcOnId = "CalcOnId",
            UnitRate = "UnitRate",
            UnitLabour = "UnitLabour",
            UnitCost = "UnitCost",
            NetAmount = "NetAmount",
            Discount = "Discount",
            DiscountPer = "DiscountPer",
            GrossAmount = "GrossAmount",
            CCGrossAmount = "CCGrossAmount",
            CCNetAmount = "CCNetAmount",
            RefTransItemId = "RefTransItemId",
            RefTransId = "RefTransId",
            ImageName = "ImageName",
            Remark = "Remark",
            SpecialRemark = "SpecialRemark",
            UserDescription = "UserDescription",
            ServerDate = "ServerDate",
            Remarks = "Remarks",
            IsDisabled = "IsDisabled",
            AckStatus = "AckStatus",
            DeliveryDate = "DeliveryDate",
            CompanyId = "CompanyId",
            BagStatus = "BagStatus",
            WstPer = "WstPer",
            WstWt = "WstWt",
            Purity = "Purity",
            PureWeight = "PureWeight",
            Status = "Status",
            MetalId = "MetalId",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            TaxCode = "TaxCode",
            HSN = "HSN",
            HasBom = "HasBom",
            Parts = "Parts",
            VoucherNo = "VoucherNo",
            TransDate = "TransDate",
            DeptName = "DeptName",
            PosCustomerCode = "PosCustomerCode",
            CustomerName = "CustomerName",
            BOMDetails = "BOMDetails",
            LaborDetails = "LaborDetails",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            BrandId = "BrandId",
            SuperTypeId = "SuperTypeId",
            CollectionId = "CollectionId",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName",
            Attribute = "Attribute",
            CalcUnitId = "CalcUnitId",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            KaratId = "KaratId",
            StockAllocation = "StockAllocation",
            ProductSizeId = "ProductSizeId",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            Lab = "Lab",
            ECommOrderId = "ECommOrderId",
            OrderStatusId = "OrderStatusId",
            OrderStatusName = "OrderStatusName"
        }
    }
}
